import React from 'react';
import { ScaleIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-white/10 bg-ink px-5 py-10 md:px-8" data-id="element-66" data-mp="3gf96f0gd6eb2">
      <div className="mx-auto max-w-5xl text-center" data-id="element-67" data-mp="3ghc486nrdbqc">
        <div className="flex items-center justify-center gap-2 text-accent" data-id="element-68" data-mp="32ovxaurqktk5">
          <ScaleIcon size={17} aria-hidden="true" data-id="element-69" data-mp="36oxyz3xh1mzf" />
          <p className="font-display text-lg font-semibold" data-id="element-70" data-mp="36ppivhhphw9v">
            CONVERSION ELITE™
          </p>
        </div>
        <p className="mt-4 text-xs leading-relaxed text-stone-500" data-id="element-71" data-mp="3ud7i1y3avwmv">
          © 2026 Conversion Elite™ — Todos los derechos reservados. Prohibida
          la reproducción total o parcial sin autorización.
        </p>
      </div>
    </footer>;
}